// Module
var code = `<div class="filled-orders-panel">
    <div class="filled-orders-panel-container-top">
        <rangeSelectPanel name='filledOrdersRangeSelect' />
    </div>

    <div class="filled-orders-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;